export enum StorageLocationBadgeType {
  Recommended = 'Recommended',
  HighlyRated = 'HighlyRated',
  OpenLate = 'OpenLate',
  Honeymoon = 'Honeymoon',
}

export interface StorageLocationItemBadge {
  type: StorageLocationBadgeType;
  text: string;
}
